import { Component, OnInit, ViewChild } from '@angular/core';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { PCTableActionInputModel } from '../../models/pc-table-action-input-model';
import { TabelPaging } from '../../interfaces/table';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import { LoggerService } from 'src/app/services/logger.service';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { EnumUtilityService } from 'src/app/services/enum-utility.service';
import { ProductType } from 'src/app/enum/product-type';
import { Drug, DrugBackEndModel } from '../../models/drug';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DropDownPagingInput } from 'src/app/models/drop-down-paging-input';
import { FormControl, FormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PCTableComponent } from '../../components/pctable/pctable.component';
import { DrugModalComponent } from '../../components/drug-modal/drug-modal.component';
import { PcsettingModalComponent } from '../../components/pcsetting-modal/pcsetting-modal.component';

@Component({
  selector: 'app-change-drug-support',
  templateUrl: './change-drug-support.component.html',
  styleUrls: ['./change-drug-support.component.css'],
})
export class ChangeDrugSupportComponent implements OnInit {
  public breadCrumb: string = '';

  public action: PCTableActionInputModel;
  public fields: any[] = [];
  public data?: PCTableInputModel;
  public paging?: TabelPaging;
  public loading: boolean = false;
  public requestModel: PCSearchRequestModel;
  public modalSuccessConfirm: boolean = false;

  @ViewChild('ModalContent') modalContent!: any;
  @ViewChild('ModalChange') ModalChange!: any;
  @ViewChild(PCTableComponent) pcTableComponent!: PCTableComponent;
  @ViewChild(DrugModalComponent) drugModalComponent!: DrugModalComponent;
  @ViewChild(PcsettingModalComponent)
  pcsettingModalComponent!: PcsettingModalComponent;

  public activeAddModal: boolean = false;
  public thisValue: Drug;
  public publicInformationError: boolean = false;
  public companyInformationError: boolean = false;
  public informationError: boolean = false;
  public FinancialError: boolean = false;
  public modalIsOpen: boolean = false;
  public loadingModal: boolean = false;

  public drugSearchForm: FormGroup;
  public activeSearch: boolean = false;
  public searchRequestModel: PCSearchRequestModel;
  public searchData?: PCTableInputModel;
  public searchPaging?: TabelPaging;

  public changeDrugValidationMessage?: string;
  public newDrugName?: string;
  public newDrugId?: string;

  public drugGenericList: any[] = [];
  public drugFormList: any[] = [];
  public drugUsageList: any[] = [];
  public companyList: any[] = [];
  public countryList: any[] = [];

  public productTypeList: any[];
  constructor(
    private logger: LoggerService,
    private modalService: NgbModal,
    private apiService: UserApiService,
    private responseService: CustomizeResponseService,
    private enumService: EnumUtilityService
  ) {
    this.productTypeList = Object.keys(ProductType)
      .filter((key) => !isNaN(Number(ProductType[key])))
      .map((key) => ({ value: ProductType[key], name: key }));
    this.thisValue = new Drug();
    this.requestModel = new PCSearchRequestModel();
    this.searchRequestModel = new PCSearchRequestModel();

    this.drugSearchForm = new FormGroup({
      drugBrandName: new FormControl(''),
    });

    this.action = new PCTableActionInputModel(
      [
        {
          name: 'Reload',
          className: 'btn-outline-primary',
          icon: 'bx bx-refresh',
        },
        {
          name: 'Settings',
          className: 'btn-outline-primary',
          icon: 'bx bx-cog',
        },
        {
          name: 'Print',
          className: 'btn-outline-primary',
          icon: 'bx bx-printer',
        },
        {
          name: 'Explanation',
          className: 'btn-outline-primary',
          icon: 'bx bx-question-mark',
        },
      ],
      '',
      []
    );

    this.breadCrumb = `CustomerSupport,ChangeDrug`;

    forkJoin([this.getData(), this.getEntity()]).subscribe(
      ([dataResult, entityResult]) => {
        if (dataResult) {
          let firstItemOnPage = 1;
          if (dataResult.data?.firstItemOnPage) {
            firstItemOnPage = dataResult.data?.firstItemOnPage;
          }

          if (dataResult.data?.pageCount! < dataResult.data?.pageNumber! && dataResult.data?.pageCount!=0) {
            this.requestModel.pageNumber = 1;
          }

          this.data = new PCTableInputModel(
            dataResult.data?.items,
            [
              {
                name: 'Edit',
                className: 'btn-outline-primary',
                icon: 'far fa-edit',
              },
              {
                name: 'ReplacementExistingDrug',
                className: 'btn-outline-warning',
                icon: 'fas fa-exchange-alt',
              },
            ],
            true,
            firstItemOnPage,
            this.requestModel.orderBy,
            this.requestModel.direction
          );

          this.paging = this.responseService.customizePaging(dataResult);
        }

        if (entityResult) {
          this.logger.addResponseLog(`Support`, entityResult, `Get Entity`);
          if (entityResult.succeeded) {
            let fields = this.apiService.convertStringToBoolean(
              entityResult.data.fields
            );

            fields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });

            this.fields = fields;
          }
        }

        setTimeout(() => {
          if (this.pcTableComponent) {
            this.pcTableComponent.InitPage();
          } else {
            console.error('PCTableComponent not found');
          }
        }, 2);

        setTimeout(() => {
          let selectStockPage = document.getElementById('selectStockPage');
          if (selectStockPage) {
            selectStockPage.classList.remove('animate__backInDown');
          }
        }, 2000);

        this.loading = false;
      },
      (error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
      }
    );
  }

  public ngOnInit(): void {
    this.drugSearchForm
      .get('drugBrandName')
      ?.valueChanges.pipe(debounceTime(1000))
      .subscribe((value) => {
        if (this.activeSearch) {
          this.searchDrug(value);
        } else {
          this.activeSearch = true;
        }
      });
  }

  public searchDrug(drugName: string): void {
    try {
      this.loadingModal = true;

      if (!drugName) {
        return;
      }

      if (this.modalIsOpen == false) {
        this.modalIsOpen = true;
      }

      let url = `BuyFactor/AdvanceSearch?pageNumber=${this.searchRequestModel.pageNumber}&pageSize=${this.searchRequestModel.pageSize}&paging=${this.searchRequestModel.paging}&orderBy=${this.searchRequestModel.orderBy}&direction=${this.searchRequestModel.direction}&search=${drugName}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            if (
              result.data?.pageCount != 0 &&
              result.data?.pageCount! < result.data?.pageNumber!
            ) {
              this.requestModel.pageNumber = 1;
            }

            this.searchData = new PCTableInputModel(
              result.data?.items,
              [],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            this.searchPaging = this.responseService.customizePaging(result);
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loadingModal = false;
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loadingModal = false;
    }
  }

  public parentSearchAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        if (this.searchRequestModel.orderBy == '') {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.orderBy != event.data) {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.direction == '') {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.direction == 'asd') {
          this.searchRequestModel.direction = 'desc';
        }

        this.searchRequestModel.orderBy = event.data;

        this.searchDrug(this.newDrugName!);
        break;
      case 'Paging':
        this.searchRequestModel.pageNumber = event.data;
        this.searchDrug(this.newDrugName!);
        break;
      case 'PageSize':
        this.searchRequestModel.pageSize = event.data;
        this.searchDrug(this.newDrugName!);
        break;
      case 'SelectItem':
        this.selectDrug(event.data);
        break;
      default:
        break;
    }
  }

  public selectDrug(item: any) {
    this.newDrugName = item.drugBrandPersianName;
    this.newDrugId = item.id;
    this.modalIsOpen = false;
    this.activeSearch = false;

    return;
  }

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.loading = true;
        if (this.requestModel.orderBy == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.orderBy != event.data) {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == 'asd') {
          this.requestModel.direction = 'desc';
        }

        this.requestModel.orderBy = event.data;

        this.getSingleData();
        break;
      case 'Search':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.search = event.data;
        this.getSingleData();
        break;
      case 'Paging':
        this.loading = true;

        this.requestModel.pageNumber = event.data;
        this.getSingleData();
        break;
      case 'PageSize':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.pageSize = event.data;
        this.getSingleData();
        break;
      case 'Reload':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.getSingleData();
        break;
      case 'Successed':
        this.modalSuccessConfirm = false;
        break;
      case 'Edit':
        this.OpenEditModal(event.data);
        this.thisValue = event.data;
        break;

      case 'CloseModal':
        this.modalService.dismissAll();
        break;

      case 'UpdateSuccess':
        this.modalService.dismissAll();
        this.modalSuccessConfirm = true;
        this.getSingleData();
        break;
      case 'ReplacementExistingDrug':
        this.newDrugName = undefined;
        this.openModal(this.ModalChange);
        this.thisValue = event.data;
        break;

      case 'Settings':
        this.pcsettingModalComponent.openSettingModal();
        break;
      case 'SubmitSetting':
        this.fields = event.data;
        if (this.pcTableComponent) {
          this.pcTableComponent.RebuildColumn();
        } else {
          console.error('PCTableComponent not found');
        }
        break;
      default:
        break;
    }
  }

  public getData() {
    const url = `Support?pageNumber=${this.requestModel.pageNumber}&pageSize=${this.requestModel.pageSize}&paging=${this.requestModel.paging}&orderBy=${this.requestModel.orderBy}&direction=${this.requestModel.direction}&search=${this.requestModel.search}`;

    return this.apiService.getAll(new ApiRequestModel(url)).pipe(
      catchError((error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
        return of(null);
      })
    );
  }

  public getSingleData() {
    try {
      this.loading = true;
      const url = `Support?pageNumber=${this.requestModel.pageNumber}&pageSize=${this.requestModel.pageSize}&paging=${this.requestModel.paging}&orderBy=${this.requestModel.orderBy}&direction=${this.requestModel.direction}&search=${this.requestModel.search}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            let firstItemOnPage = result.data?.firstItemOnPage || 1;

            if (
              result.data?.pageCount != 0 &&
              result.data?.pageCount! < result.data?.pageNumber!
            ) {
              this.requestModel.pageNumber = 1;
              this.getSingleData();
            }

            this.data = new PCTableInputModel(
              result.data?.items,
              [
                {
                  name: 'Edit',
                  className: 'btn-outline-primary',
                  icon: 'far fa-edit',
                },
                {
                  name: 'ReplacementExistingDrug',
                  className: 'btn-outline-warning',
                  icon: 'fas fa-exchange-alt',
                },
              ],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            const matTable = document.querySelector('.table-responsive');
            if (matTable != null) {
              matTable.scrollTop = 0;
            }

            this.paging = this.responseService.customizePaging(result);
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public getEntity() {
    return this.apiService
      .getEntity(
        new ApiRequestModel(`/Drug`, null, undefined, `Support`, `Drug`)
      )
      .pipe(
        catchError((error) => {
          this.apiService.AddErrorLog(error);
          return of(null);
        })
      );
  }

  public checkValidation(): boolean {
    const requiredMessage = 'وارد کردن این فیلد اجباری می باشد';
    const minLengthMessage = 'مقدار این فیلد نمیتواند کمتر از 3 کاراکتر باشد';
    let isSucceed = true;
    this.publicInformationError = false;
    this.companyInformationError = false;
    this.informationError = false;
    this.FinancialError = false;

    if (this.thisValue == null) {
      return false;
    }

    if (this.thisValue.name == null || this.thisValue.name == '') {
      this.thisValue.nameHint = requiredMessage;
      this.publicInformationError = true;
    } else if (this.thisValue.name.length < 3) {
      this.thisValue.nameHint = minLengthMessage;
      this.publicInformationError = true;
    } else {
      this.thisValue.nameHint = undefined;
    }

    if (
      this.thisValue.persianName == null ||
      this.thisValue.persianName == ''
    ) {
      this.thisValue.persianNameHint = requiredMessage;
      this.publicInformationError = true;
    } else if (this.thisValue.persianName.length < 3) {
      this.thisValue.persianNameHint = minLengthMessage;
      this.publicInformationError = true;
    } else {
      this.thisValue.persianNameHint = undefined;
    }

    if (this.thisValue.flavor == null || this.thisValue.flavor == '') {
      this.thisValue.flavorHint = undefined;
    } else if (this.thisValue.flavor.length < 3) {
      this.thisValue.flavorHint = minLengthMessage;
      this.publicInformationError = true;
    } else {
      this.thisValue.flavorHint = undefined;
    }

    // if (this.thisValue.erxCode == null || this.thisValue.erxCode == '') {
    //   this.thisValue.erxCodeHint = requiredMessage;
    //   this.publicInformationError = true;
    // } else if (this.thisValue.erxCode.length < 3) {
    //   this.thisValue.erxCodeHint = minLengthMessage;
    //   this.publicInformationError = true;
    // } else {
    //   this.thisValue.erxCodeHint = undefined;
    // }

    // if (this.thisValue.irc == null || this.thisValue.irc == '') {
    //   this.thisValue.ircHint = requiredMessage;
    //   this.publicInformationError = true;
    // } else if (this.thisValue.irc.length < 3) {
    //   this.thisValue.ircHint = minLengthMessage;
    //   this.publicInformationError = true;
    // } else {
    //   this.thisValue.ircHint = undefined;
    // }

    // if (this.thisValue.gtn == null || this.thisValue.gtn == '') {
    //   this.thisValue.gtnHint = requiredMessage;
    //   this.publicInformationError = true;
    // } else if (this.thisValue.gtn.length < 3) {
    //   this.thisValue.gtnHint = minLengthMessage;
    //   this.publicInformationError = true;
    // } else {
    //   this.thisValue.gtnHint = undefined;
    // }

    if (
      this.thisValue.drugGenericId == null ||
      this.thisValue.drugGenericId == ''
    ) {
      this.thisValue.drugGenericHint = requiredMessage;
      this.publicInformationError = true;
    } else {
      this.thisValue.drugGenericHint = undefined;
    }

    if (this.thisValue.drugFormId == null || this.thisValue.drugFormId == '') {
      this.thisValue.drugFormHint = requiredMessage;
      this.publicInformationError = true;
    } else {
      this.thisValue.drugFormHint = undefined;
    }

    if (
      this.thisValue.drugUsageId == null ||
      this.thisValue.drugUsageId == ''
    ) {
      this.thisValue.drugUsageHint = requiredMessage;
      this.publicInformationError = true;
    } else {
      this.thisValue.drugUsageHint = undefined;
    }

    if (
      this.thisValue.creatorCompanyId == null ||
      this.thisValue.creatorCompanyId == ''
    ) {
      this.thisValue.creatorCompanyHint = requiredMessage;
      this.companyInformationError = true;
    } else {
      this.thisValue.creatorCompanyHint = undefined;
    }

    if (
      this.thisValue.licenseCompanyId == null ||
      this.thisValue.licenseCompanyId == ''
    ) {
      this.thisValue.licenseCompanyHint = requiredMessage;
      this.companyInformationError = true;
    } else {
      this.thisValue.licenseCompanyHint = undefined;
    }

    if (this.thisValue.countryId == null || this.thisValue.countryId == '') {
      this.thisValue.countryHint = requiredMessage;
      this.companyInformationError = true;
    } else {
      this.thisValue.countryHint = undefined;
    }

    if (
      this.thisValue.drugPackageCount == null ||
      this.thisValue.drugPackageCount == 0
    ) {
      this.thisValue.drugPackageHint = requiredMessage;
      this.informationError = true;
    } else {
      this.thisValue.drugPackageHint = undefined;
    }

    if (
      this.thisValue.keepingTypeId == null ||
      this.thisValue.keepingTypeId == ''
    ) {
      this.thisValue.keepingTypeHint = requiredMessage;
      this.informationError = true;
    } else {
      this.thisValue.keepingTypeHint = undefined;
    }

    if (this.thisValue.productTypeEnum == null) {
      this.thisValue.productTypeHint = requiredMessage;
      this.informationError = true;
    } else {
      this.thisValue.productTypeHint = undefined;
    }

    if (this.thisValue.buyPrice == null || this.thisValue.buyPrice == 0) {
      this.thisValue.buyPriceHint = requiredMessage;
      this.FinancialError = true;
    } else if (this.thisValue.buyPrice < 500) {
      this.thisValue.buyPriceHint = minLengthMessage;
      this.FinancialError = true;
    } else {
      this.thisValue.buyPriceHint = undefined;
    }

    if (this.thisValue.sellPrice == null || this.thisValue.sellPrice == 0) {
      this.thisValue.costHint = requiredMessage;
      this.FinancialError = true;
    } else if (this.thisValue.sellPrice < 500) {
      this.thisValue.costHint = minLengthMessage;
      this.FinancialError = true;
    } else {
      this.thisValue.costHint = undefined;
    }

    if (
      this.publicInformationError == false &&
      this.companyInformationError == false &&
      this.informationError == false &&
      this.FinancialError == false
    ) {
      return true;
    }
    return false;
  }

  public saveEdit() {
    try {
      if (this.checkValidation() == false) {
        return;
      }
      this.loadingModal = true;

      let url = `Drug/${this.thisValue!.id}`;

      const backendJson = this.toJSON();

      console.log(backendJson);

      this.apiService
        .patchItem(new ApiRequestModel(url, backendJson))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.modalService.dismissAll();
              this.modalSuccessConfirm = true;
              this.getSingleData();
              this;
            } else {
              this.logger.addBackEndMessage(result);
            }

            this.loadingModal = false;
          },

          (error) => {
            this.apiService.AddErrorLog(error);
            this.loadingModal = false;
          },
          () => {
            this.loadingModal = false;
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  private toJSON(): DrugBackEndModel {
    if (this.thisValue == null) {
      return new DrugBackEndModel();
    }

    return {
      name: this.thisValue.name,
      persianName: this.thisValue.persianName,
      // erxCode: this.thisValue.erxCode,
      // irc: this.thisValue.irc,
      // gtn: this.thisValue.gtn,
      attachment: this.thisValue.attachment,
      sellPrice: this.thisValue.sellPrice,
      buyPrice: this.thisValue.buyPrice,
      flavor: this.thisValue.flavor,
      drugGenericId: this.thisValue.drugGenericId,
      drugFormId: this.thisValue.drugFormId,
      drugUsageId: this.thisValue.drugUsageId,
      creatorCompanyId: this.thisValue.creatorCompanyId,
      countryId: this.thisValue.countryId,
      drugPackageCount: this.thisValue.drugPackageCount,
      keepingTypeId: this.thisValue.keepingTypeId,
      licenseCompanyId: this.thisValue.licenseCompanyId,
      productTypeEnum: this.thisValue.productType,
    };
  }

  public OpenEditModal(item: Drug) {
    if (this.modalIsOpen) {
      return;
    }
    this.activeAddModal = false;
    this.thisValue = item;
    this.openModal(this.modalContent);
  }

  private openModal(modalIdentity: any) {
    try {
      this.modalIsOpen = true;
      this.modalService
        .open(modalIdentity, {
          size: 'xl',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static',
        })
        .result.then(
          (result) => {
            this.modalIsOpen = false;
            if (result == 'Save click') {
              //this.callParent('Save', this.thisValue);
            }
          },
          (reason) => {
            this.modalIsOpen = false;
          }
        );
    } catch (error) {
      this.modalIsOpen = false;
      this.logger.addException(error, false);
    }
  }

  public saveChangeDrug() {
    try {
      if (this.thisValue.id == undefined || this.newDrugId == undefined) {
        this.logger.addError(
          'مشخص کردن دارو جدید و دارو جایگرین اجباری است',
          false
        );
        return;
      }

      this.loading = true;

      let url = `Support/ExchangeByExistDrug`;

      const backendJson = {
        oldDrugId: this.thisValue.id,
        newDrugId: this.newDrugId,
      };

      console.log(backendJson);

      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          if (result.succeeded) {
            this.modalService.dismissAll();
            this.modalSuccessConfirm = true;
            this.getSingleData();
          } else {
            this.logger.addBackEndMessage(result);
          }

          this.loading = false;
        },

        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }
}
